import React from "react";
import { EmojiConfirmPopupPropTypes } from "./types";
import Popup from "../Popup";
import Headline from "../Typography/Headline";
import { CloseIcon } from "../Icons";
import Button from "../Button";
import i18next from "i18next";

const EmojiConfirmPopup = ({
    open,
    setOpen,
    onConfirm,
    onCancel,
    emoji = "😭",
    title,
    infoText,
    ctaText = "",
    ctaBtnVariant = "danger",
    closeBtnVariant = "secondary",
    closeBtnText = "",
    twoBtns = true,
    closable = true,
}) => {
    return (
        <Popup open={open} handleClose={() => closable && setOpen(false)}>
            <div className="emoji-confirm-popup">
                {closable && (
                    <CloseIcon
                        onClick={() => {
                            setOpen(false);
                            onCancel && onCancel();
                        }}
                        customClass="emoji-confirm-popup__close-btn"
                    />
                )}

                <span className="emoji-confirm-popup__emoji">{emoji}</span>
                {title && (
                    <Headline size={5} className="emoji-confirm-popup__title">
                        {title}
                    </Headline>
                )}
                {infoText && (
                    <p className="emoji-confirm-popup__info-text">{infoText}</p>
                )}

                {twoBtns && (
                    <Button
                        onClick={onConfirm}
                        variant={ctaBtnVariant}
                        label={ctaText}
                        size={"SM"}
                    />
                )}

                <Button
                    onClick={() => {
                        setOpen(false);
                        onCancel && onCancel();
                    }}
                    variant={closeBtnVariant}
                    label={
                        closeBtnText === ""
                            ? i18next.t("popup.close")
                            : closeBtnText
                    }
                    size={"SM"}
                />
            </div>
        </Popup>
    );
};

EmojiConfirmPopup.propTypes = EmojiConfirmPopupPropTypes;
export default EmojiConfirmPopup;
